import React from 'react';
import classnames from 'classnames';
import { InlineIcon } from '../../../../../../inline-icon/inline-icon';
import styles from '../../card.scss';
import contentStyles from './card-content.scss';
import ScheduledIcon from '../../../../../../../icons/compiled/components/ScheduledIcon';
import TriangleIcon from '../../../../../../../icons/compiled/components/TriangleIcon';
import { ItemType } from '@wix/wix-vod-constants/api-types';
export class VideoCardContent extends React.Component {
  isLiveVideo() {
    const {
      itemType
    } = this.props.cardData;
    return itemType === ItemType.ItemLive;
  }
  isScheduledVideo() {
    const {
      itemType
    } = this.props.cardData;
    return itemType === ItemType.ItemScheduled;
  }
  renderThumbnail() {
    const {
      cardData
    } = this.props;
    const {
      thumbnailUrl
    } = cardData;
    if (!thumbnailUrl) {
      return this.isScheduledVideo() ? this.renderScheduledPlaceholder() : null;
    }
    return /*#__PURE__*/React.createElement("div", {
      className: styles.thumbnail
    }, /*#__PURE__*/React.createElement("div", {
      className: styles.image,
      style: {
        backgroundImage: `url(${thumbnailUrl})`
      }
    }), this.renderThumbnailIcon());
  }
  renderThumbnailIcon() {
    if (this.isLiveVideo()) {
      return /*#__PURE__*/React.createElement("div", {
        className: contentStyles['thumbnail-circle']
      });
    }
    return /*#__PURE__*/React.createElement(InlineIcon, {
      icon: /*#__PURE__*/React.createElement(TriangleIcon, null),
      className: contentStyles['thumbnail-icon']
    });
  }
  renderScheduledPlaceholder() {
    return /*#__PURE__*/React.createElement("div", {
      className: styles.thumbnail
    }, /*#__PURE__*/React.createElement("div", {
      className: contentStyles['scheduled-placeholder']
    }, /*#__PURE__*/React.createElement(InlineIcon, {
      icon: /*#__PURE__*/React.createElement(ScheduledIcon, null),
      className: contentStyles['scheduled-icon']
    })));
  }
  renderText() {
    const {
      cardData
    } = this.props;
    const {
      text
    } = cardData;
    return /*#__PURE__*/React.createElement("div", {
      className: styles.text
    }, /*#__PURE__*/React.createElement("div", {
      className: styles['text-content'],
      "data-hook": "action-card-title"
    }, text));
  }
  renderScheduledText() {
    const {
      cardData
    } = this.props;
    const {
      text,
      liveLabel
    } = cardData;
    return /*#__PURE__*/React.createElement("div", {
      className: contentStyles['scheduled-text']
    }, /*#__PURE__*/React.createElement("span", {
      className: contentStyles['scheduled-time']
    }, liveLabel), /*#__PURE__*/React.createElement("div", {
      className: contentStyles['scheduled-title'],
      "data-hook": "action-card-title"
    }, text));
  }
  renderCtaIcon() {
    if (this.isLiveVideo()) {
      return /*#__PURE__*/React.createElement("div", {
        className: contentStyles['cta-circle']
      });
    }
    return /*#__PURE__*/React.createElement("span", {
      className: classnames(styles['cta-icon-container'], styles['cta-play-container'])
    }, /*#__PURE__*/React.createElement(InlineIcon, {
      icon: /*#__PURE__*/React.createElement(TriangleIcon, null),
      className: styles['icon-play']
    }));
  }
  renderCta() {
    const {
      cardData
    } = this.props;
    const {
      buttonLabel
    } = cardData;
    return /*#__PURE__*/React.createElement("div", {
      className: styles.cta
    }, this.renderCtaIcon(), /*#__PURE__*/React.createElement("div", {
      className: styles['cta-label'],
      "data-hook": "action-card-action-text"
    }, buttonLabel));
  }
  render() {
    const {
      className,
      isAriaHidden
    } = this.props;
    const isScheduledVideo = this.isScheduledVideo();
    const contentClassName = classnames(className, {
      [styles.live]: this.isLiveVideo(),
      [styles.scheduled]: isScheduledVideo
    });
    return /*#__PURE__*/React.createElement("div", {
      className: contentClassName,
      "aria-hidden": isAriaHidden
    }, this.renderThumbnail(), /*#__PURE__*/React.createElement("div", {
      className: styles.container
    }, isScheduledVideo ? this.renderScheduledText() : this.renderText(), !isScheduledVideo && this.renderCta()));
  }
}
//# sourceMappingURL=card-content.js.map